import { Injectable, ResourceRef, Signal, computed, inject } from "@angular/core";
import { HttpDataService, IResponseWrapper } from "./httpdata.service";
import { environment } from "src/environments/environment";
import { NearbySaleDto } from "src/models/sales/nearby-sales.model";
import { ShareSalesDto } from "src/models/estate/share-sales.model";
import { NearbySiteSaleDto } from "src/models/sales/nearby-site-sales.model";
import { map } from "rxjs/internal/operators/map";
import { ImagePackage } from "src/models/common/image.model";
import { ResourceService } from "./resources/resource.service";
import { catchError } from "rxjs/internal/operators/catchError";
import { Observable } from "rxjs/internal/Observable";
import { of } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class SalesDataService {
    private http: HttpDataService = inject(HttpDataService);
    private resourceService = inject(ResourceService);

    getShareSalesInformationHttp(unitId: number) {
        return this.http
            .get<IResponseWrapper<ShareSalesDto[]>>(`${environment.apiUrl}/Sales/${unitId}/RealEstateShareSales`)
            .pipe(map((response) => response.data));
    }

    getNearbySalesHttp(unitId: number) {
        return this.http
            .get<IResponseWrapper<NearbySaleDto[]>>(`${environment.apiUrl}/Sales/${unitId}/NearbySalesByUnitId`)
            .pipe(map((response) => response.data));
    }

    getNearbySiteSalesHttp(unitId: number) {
        return this.http
            .get<IResponseWrapper<NearbySiteSaleDto[]>>(`${environment.apiUrl}/Sales/${unitId}/NearbySiteSales`)
            .pipe(map((response) => response.data));
    }

    getShareSalesInformationResource(unitId: Signal<number>): ResourceRef<ShareSalesDto[] | null> {
        const url = computed(() => (unitId() ? `${environment.apiUrl}/Sales/${unitId()}/RealEstateShareSales` : null));
        return this.http.getResource<ShareSalesDto[]>(url);
    }

    getNearbySalesResource(unitId: Signal<number>): ResourceRef<NearbySaleDto[] | null> {
        const url = computed(() => (unitId() ? `${environment.apiUrl}/Sales/${unitId()}/NearbySalesByUnitId` : null));
        return this.http.getResource<NearbySaleDto[]>(url);
    }

    getNearbySiteSalesResource(unitId: Signal<number>): ResourceRef<NearbySiteSaleDto[] | null> {
        const url = computed(() => (unitId() ? `${environment.apiUrl}/Sales/${unitId()}/NearbySiteSales` : null));
        return this.http.getResource<NearbySiteSaleDto[]>(url);
    }
    getSalesImagesResource(unitId: number, saleId?: number): Observable<ImagePackage[]> {
        let url = `${environment.apiUrl}/Sales/${unitId}/GetSalesImages`;
        if (saleId) {
            url += `?saleId=${saleId}`;
        }

        return this.http.get<IResponseWrapper<ImagePackage[]>>(url).pipe(
            map((response) => response.data),
            map((images) => this.mapImagesToUrls(images)),
            catchError(() => of([]))
        );
    }

    private mapImagesToUrls(incomingImagePackages: ImagePackage[]): any {
        if (incomingImagePackages != null && incomingImagePackages.length > 0) {
            incomingImagePackages.forEach((imagePackage: any) => {
                if (imagePackage.images && imagePackage.images.length > 0) {
                    imagePackage.images.forEach((image: any) => {
                        image.imageUrl = this.resourceService.getImageUrl(image.imageId);
                        image.imageThumbnailUrl = this.resourceService.getImageUrl(image.imageId, true);
                    });
                }
            });
        }
        return incomingImagePackages || [];
    }
}
